// extracted by mini-css-extract-plugin
export default {"listContainer":"List_listContainer__aav0z","emptyListText":"List_emptyListText__DfyRH"};